










































































































































import Vue from 'vue'
import { mask } from 'vue-the-mask'
import {
  carAgencyController,
  carCategoryController,
  carContractSharedController,
  carOfficeController,
  carSeasonsController,
} from '~/api/RentalCar'
import AppView from '~/components/AppView.vue'
import Autocomplete from '~/components/Autocomplete.vue'
import DateTimePicker from '~/components/DateTimePicker.vue'
import TextButton from '~/components/TextButton.vue'
import { TableHeader } from '~/utils/interfaces'
import { CarContract, CreateCarContract } from '~/utils/interfaces/rentalCar'
export default Vue.extend({
  components: {
    AppView,
    Autocomplete,
    DateTimePicker,
    TextButton,
  },
  directives: {
    mask,
  },
  data() {
    return {
      controller: carContractSharedController,
      headers: [
        {
          text: this.$t('name'),
          value: 'name',
        },
        {
          text: this.$t('shared_with'),
          value: 'agency_name',
        },
        {
          text: this.$t('car_agency'),
          value: 'car_agency_name',
        },
        {
          text: this.$t('is_active'),
          value: 'is_active',
        },
      ] as TableHeader<CarContract>[],
      defaultCrud: {
        agency: this.$store.state.profile.agency,
        car_agency: '',
        description: '',
        name: '',
        start_date: '',
        end_date: '',
        offices: [],
        prices: [
          {
            category: '',
            cost: '',
            max_days: '',
            min_days: 1,
            price: '',
            season: '',
          },
        ],
      },
      defaultCarContractPrice: {
        category: '',
        cost: '',
        price: '',
        max_days: 1,
        min_days: 0,
        season: '',
      },
    }
  },
  methods: {
    getCarAgencies: carAgencyController.getter,
    getCarOffices: carOfficeController.getter,
    getCarCategories: carCategoryController.getter,
    getCarSeason: carSeasonsController.getter,
    addContractPrice(crud: CreateCarContract) {
      crud.prices.push({ ...this.defaultCarContractPrice })
    },
  },
})
